import type { EmbedPage } from "@/features/supabase";
import { CaretDownIcon } from "@phosphor-icons/react";
import { getDatasetBlurb } from "../functions";
interface DatasetSelectButtonProps {
  selectedDataset?: EmbedPage;
  onClick: () => void;
}

/**
 * The dataset picker's trigger. Styled as a dropdown so it reads as the thing that
 * changes the dashboard, though it opens the full picker modal rather than a menu.
 */
export const DatasetSelectButton = ({
  selectedDataset,
  onClick
}: DatasetSelectButtonProps) => {
  const blurb = selectedDataset ? getDatasetBlurb(selectedDataset) : "";
  return <button type="button" onClick={onClick} aria-haspopup="dialog" aria-label="Select dataset" className="flex h-9 min-w-0 max-w-[420px] items-center gap-3 rounded-lg border border-gray-200 bg-surface px-3 text-left transition-colors hover:border-gray-400" data-sentry-component="DatasetSelectButton" data-sentry-source-file="DatasetSelectButton.tsx">
      <span className="flex min-w-0 flex-col leading-tight">
        <span className={`truncate text-sm font-medium ${selectedDataset ? "text-gray-900" : "text-gray-400"}`} title={selectedDataset?.title}>
          {selectedDataset?.title ?? "Select a dataset"}
        </span>
        {blurb && <span className="truncate text-xs text-gray-500" title={blurb}>
            {blurb}
          </span>}
      </span>

      <CaretDownIcon weight="bold" className="ml-auto shrink-0 text-gray-500" data-sentry-element="CaretDownIcon" data-sentry-source-file="DatasetSelectButton.tsx" />
    </button>;
};